<!-- explain [ 说明 ] -->
<template>

    <div id='explain'>
        <router-view></router-view>
    </div>

</template>

<script>
export default {
    components: { },

    props: [],

    data() {
        return{

        }
    },

    computed: { },

    watch: {
        route: {
            handler: function(val, old){

            },
            deep: true
        }
    },

    created(){

    },

    mounted(){
        this.loadMain();

        this.getData();
    },

    methods:{
        loadMain(){

        },

        getData(){

        },
    },
}
</script>


// WEBPACK FOOTER //
// explain.vue?86bf0b88